/**
 * Label text for the optional CoCM referral toggle.
 * @agentic connections
 */
export const COCM_REFERRAL_TOGGLE_LABEL =
  "Would you also like to initiate triage-based referrals to external services?";

/**
 * Title for the shared referrals section.
 * @agentic connections
 */
export const REFERRALS_SECTION_TITLE = "Referrals";

/**
 * Label for the service-needs referral field.
 * @agentic connections
 */
export const REFERRAL_FIELD_LABEL = "Refer to External Services";

/**
 * Description for the service-needs referral field.
 * @agentic connections
 */
export const REFERRAL_FIELD_DESCRIPTION =
  "As a part of the triage activities, add specific service needs and preferences to facilitate the member's outbound referrals.";

/**
 * Title for the communication & handoff section.
 * @agentic connections
 */
export const COMMUNICATION_HANDOFF_SECTION_TITLE =
  "Communication & Handoff" as const;

/**
 * Label for the clinician-contact-only flag toggle.
 * @agentic connections
 */
export const CLINICIAN_CONTACT_ONLY_LABEL = "Clinician Contact Only" as const;

/**
 * Description for the clinician-contact-only flag toggle.
 * @agentic connections
 */
export const CLINICIAN_CONTACT_ONLY_DESCRIPTION =
  "Complex case — Lead Advocate maintains all member communication" as const;

/**
 * Label for the clinician approval switch.
 * @agentic connections
 */
export const REFERRAL_APPROVAL_LABEL = "Require approval for selected services";

/**
 * Description for the clinician approval switch.
 * @agentic connections
 */
export const REFERRAL_APPROVAL_DESCRIPTION =
  "When enabled, a clinician approval step will be added before the referral workflow begins.";
